// extracted by mini-css-extract-plugin
module.exports = {"FormControl":"PrimarySelect_FormControl__26ajA","Narrow":"PrimarySelect_Narrow__38fJf","VeryNarrow":"PrimarySelect_VeryNarrow__2TceV","FullWidth":"PrimarySelect_FullWidth__1JFOs"};